module.exports = __webpack_public_path__ + "static/media/30OIOS12.963d7fe9.jpg";